'use strict'

function initializeSlider() {
  $(document).ready(function () {
    // Initialize Slick-Slicker
    //initSlider()
    initDefaultSlider()
    initGridSlider()
    initVtsSlider()
    initCaseSlider()
  })

  function initSlider() {
    const $slider = $('.slider:not(.slider--default):not(.slider--grid):not(.slider--vts)')

    $slider.each(function (i, el) {
      const $this = $(el)
      let contWidth = 0
      if (contWidth < $(window).width()) {
        contWidth = ($(window).width() * 0.5) + ($('.container-fluid').outerWidth() / 2)
      } else {
        contWidth = $('.container-fluid').outerWidth()
      }
      const sliderElement = $this.find('.slider__slide > div')
      const noOfSlides = sliderElement.length

      let itemWidth = sliderElement.outerWidth() + 16
      // if (sliderElement.hasClass('news-teaser') || sliderElement.hasClass('press-teaser')) {
      //   itemWidth = sliderElement.outerWidth() + 40
      // }
      $this.slick({
        slidesToScroll: 1,
        variableWidth: true,
        infinite: false,
        slidesToShow: ((noOfSlides * itemWidth) < contWidth) ? contWidth / itemWidth : (contWidth / itemWidth),
        arrows: ((noOfSlides * itemWidth) >= contWidth),
        prevArrow: '<button type="button" class="slick-prev"><i class="material-icons-outlined">chevron_left</i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="material-icons-outlined">chevron_right</i></button>',
        dots: false,
        touchThreshold: 10,
        focusOnSelect: true,
        swipeToSlide: true
      })
      if ($this.find('button.slick-arrow').length) {
        $this.css('padding-bottom', '72px')
      }
    })
  }

  function initDefaultSlider() {
    const $defSlider = $('.slider--default')

    $defSlider.each(function (i, el) {
      const $this = $(el)
      const sliderElement = $this.find('.slider__slide')
      const noOfSlides = sliderElement.length
      let slidesToShow = 1
      let fade = false
      let adaptiveHeight = false
      let prevArrow = '<button type="button" class="slick-prev"><i class="material-icons-outlined">chevron_left</i></button>'
      let nextArrow = '<button type="button" class="slick-next"><i class="material-icons-outlined">chevron_right</i></button>'
      let responsive = []
      let statusText = $this.parent().find('.slick-paging-info');
      $this.on('init reInit beforeChange', function (event, slick, currentSlide, nextSlide) {
        if (statusText.length > 0) {
          // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
          let i = (nextSlide ? nextSlide : 0) + 1;
          statusText.html(i + ' <span class="color-neutrals-50">/ ' + slick.slideCount + '</span>');
        }
      });
      if ($this.hasClass('slider--cards')) {
        slidesToShow = 5
        responsive = [{
            breakpoint: 1301,
            settings: {
              slidesToShow: slidesToShow,
            }
          },
          {
            breakpoint: 1201,
            settings: {
              slidesToShow: 4,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: (noOfSlides > 1) ? 3.4 : 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: (noOfSlides > 1) ? 2.4 : 1,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: (noOfSlides > 1) ? 1.4 : 1,
            }
          }
        ]
      }
      if ($this.hasClass('slider--gallery')) {
        fade = true;
      }
      if ($this.hasClass('slider--history')) {
        adaptiveHeight = true;
        prevArrow = '<button type="button" class="slick-prev"><span class="slider-nav__text"></span><i class="material-icons-outlined">arrow_back</i></button>'
        nextArrow = '<button type="button" class="slick-next"><span class="slider-nav__text"></span><i class="material-icons-outlined">arrow_forward</i></button>'
      }
      if ($this.hasClass('slider--news')) {
        slidesToShow = 4
        responsive = [{
            breakpoint: 1201,
            settings: {
              slidesToShow: slidesToShow,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: (noOfSlides > 1) ? 1.3 : 1,
            }
          }
        ]
        if ($this.hasClass('slider--devider')) {
          let classNames = $this.parents('.grid__item').prop('className').replace("col-sm-12", "")
          let checkCols = classNames.replace(/[^0-9\.]+/g, "")
          console.log(checkCols)
          if (checkCols == '6') {
            $this.addClass('slider--news--col-6')
            slidesToShow = 2
            responsive = [{
                breakpoint: 1201,
                settings: {
                  slidesToShow: slidesToShow,
                }
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 3,
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: slidesToShow,
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: (noOfSlides > 1) ? 1.3 : 1,
                }
              }
            ]
          }
        }
      }
      if (!$this.hasClass("slick-initialized")) {
        $this.slick({
          slidesToShow: slidesToShow,
          slidesToScroll: 1,
          infinite: false,
          arrows: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          dots: false,
          touchThreshold: 10,
          focusOnSelect: true,
          swipeToSlide: true,
          fade: fade,
          responsive: responsive,
          adaptiveHeight: adaptiveHeight
        })

        // Init video pause
        $this.on('beforeChange', function (e, currentSlide, nextSlide) {
          $.each(window.videoPlayers, function (i, player) {
            // Pause each running video
            if (player.playing === true) {
              player.pause()
            }
          })
        })
        /* On slide change, scroll to top of slider */
        if ($this.hasClass('slider--history')) {
          // change slider nav arrows
          changeSliderNavText($this, 0)
          // after slide changed
          $this.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('html, body').animate({
              scrollTop: $(".slider-nav").offset().top
            }, 500);
            // Change slider nav arrows
            changeSliderNavText($this, nextSlide)
            $('.slider-nav__list li a').removeClass('active')
            $('.slider-nav__list li a').eq(nextSlide).addClass('active')
          });
          // Slider nav
          $('.slider-nav__list li:first-child a').addClass('active')
          // set up the click listener
          $('.slider-nav__list li a').click(function (e) {
            e.preventDefault()
            // $('.slider-nav__list li a').removeClass('active')
            // $(this).addClass('active')
            let match = $('.slider__slide[data-group=' + $(this).data('group') + ']')
            let slidenum = $('.slider__slide').index(match);
            if (slidenum >= 0) $this.slick('slickGoTo', slidenum);
            //console.log('slidenum', slidenum, 'datag',$(this).data('group'));
          })
        }
      }
      if ($this.find('button.slick-arrow').length) {
        if (!$this.hasClass('slider--gallery')) {
          $this.css('padding-bottom', '72px')
        }
      }
    })
  }

  function changeSliderNavText(slider, currentSlide) {
    let prevSlideText = ''
    if (currentSlide > 0) {
      prevSlideText = $('.slider-nav__list li').eq(currentSlide - 1).text()
    }
    let nextSlideText = ''
    if (currentSlide < slider.slick("getSlick").slideCount) {
      nextSlideText = $('.slider-nav__list li').eq(currentSlide + 1).text()
    }
    let prevArrow = '<button type="button" class="slick-prev"><i class="material-icons-outlined">arrow_back</i><span class="slider-nav__text">' + prevSlideText + '</span></button>'
    let nextArrow = '<button type="button" class="slick-next"><span class="slider-nav__text">' + nextSlideText + '</span><i class="material-icons-outlined">arrow_forward</i></button>'
    // Update arrows
    slider.slick('slickSetOption', {
      'prevArrow': prevArrow,
      'nextArrow': nextArrow
    }, true)
  }

  function initGridSlider() {
    const $gridSlider = $('.slider--grid .slider__element')
    const $addArrows = true

    $gridSlider.each(function (i, el) {
      const $this = $(el)
      let contWidth = 0
      if (contWidth < $(window).width()) {
        contWidth = ($(window).width() * 0.5) + ($('.container-fluid').outerWidth() / 2)
      } else {
        contWidth = $('.container-fluid').outerWidth()
      }
      const sliderElement = $this.find('.grid__item')
      const noOfSlides = sliderElement.length

      // Add navigation
      if ($addArrows) {
        const $parentContainer = $this.parents('section').find('.container-fluid')
        if (!$parentContainer.children('.slider__arrow-wrap').length) {
          $parentContainer.append('<div class="slider__arrow-wrap hidden visible-sm"></div>')
        }
      }

      let responsive = [{
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 992,
          settings: "unslick"
        }
      ]
      if (!$this.hasClass("slick-initialized")) {
        $this.slick({
          slidesToShow: (noOfSlides > 1) ? 1.3 : 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: $addArrows,
          mobileFirst: true,
          prevArrow: '<button type="button" class="slick-prev"><i class="material-icons-outlined">chevron_left</i></button>',
          nextArrow: '<button type="button" class="slick-next"><i class="material-icons-outlined">chevron_right</i></button>',
          appendArrows: $this.parents('section').find('.slider__arrow-wrap'),
          dots: false,
          touchThreshold: 10,
          focusOnSelect: true,
          swipeToSlide: true,
          responsive: responsive
        })
      }
    })
  }

  function initVtsSlider() {
    const $gridSlider = $('.slider--vts .slider__element')
    const $addArrows = true

    $gridSlider.each(function (i, el) {
      const $this = $(el)
      let contWidth = 0
      if (contWidth < $(window).width()) {
        contWidth = ($(window).width() * 0.5) + ($('.container-fluid').outerWidth() / 2)
      } else {
        contWidth = $('.container-fluid').outerWidth()
      }
      const sliderElement = $this.find('.grid__item')
      const noOfSlides = sliderElement.length

      // Add navigation
      if ($addArrows) {
        const $parentContainer = $this.parents('.slider--vts').find('.container-fluid')
        if (!$parentContainer.children('.slider__arrow-wrap').length) {
          $parentContainer.append('<div class="slider__arrow-wrap hidden visible-sm"></div>')
        }
      }

      let responsive = [{
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 992,
          settings: "unslick"
        }
      ]
      if (!$this.hasClass("slick-initialized")) {
        $this.slick({
          slidesToShow: (noOfSlides > 1) ? 1.3 : 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: $addArrows,
          mobileFirst: true,
          prevArrow: '<button type="button" class="slick-prev"><i class="material-icons-outlined">chevron_left</i></button>',
          nextArrow: '<button type="button" class="slick-next"><i class="material-icons-outlined">chevron_right</i></button>',
          appendArrows: $this.parents('section').find('.slider__arrow-wrap'),
          dots: false,
          touchThreshold: 10,
          focusOnSelect: true,
          swipeToSlide: true,
          responsive: responsive
        })
      }
    })
  }

  function initCaseSlider() {
    const $gridSlider = $(".slider--case .slider__element");
    const $addArrows = true;

    $gridSlider.each(function (i, el) {
      const $this = $(el);
      let contWidth = 0;
      if (contWidth < $(window).width()) {
        contWidth =
          $(window).width() * 0.5 + $(".container-fluid").outerWidth() / 2;
      } else {
        contWidth = $(".container-fluid").outerWidth();
      }

      const sliderElement = $this.find(".grid__item");
      const noOfSlides = sliderElement.length;

      // Add navigation
      if ($addArrows) {
        const $parentContainer = $this
          .parents("section")
          .find(".slider-container");
        if (!$parentContainer.children(".slider__arrow-wrap").length) {
          $parentContainer.append(
            '<div class="slider__arrow-wrap hidden visible-sm"></div>'
          );
        }
      }

      let responsive = [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 992,
          settings: "unslick",
        },
      ];

      let appendArrowElement = $this.closest("section").find(".slider__arrow-wrap")

      if (!$this.hasClass("slick-initialized")) {
        $this.slick({
          slidesToShow: noOfSlides > 1 ? 1.3 : 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: $addArrows,
          mobileFirst: true,
          prevArrow:
            '<button type="button" class="slick-prev"><i class="material-icons-outlined">chevron_left</i></button>',
          nextArrow:
            '<button type="button" class="slick-next"><i class="material-icons-outlined">chevron_right</i></button>',
          appendArrows: appendArrowElement,
          dots: false,
          touchThreshold: 10,
          focusOnSelect: true,
          swipeToSlide: true,
          responsive: responsive,
        });
      }
    });
  }

  $(window).resize(function () {
    initDefaultSlider()
    initGridSlider()
    initVtsSlider()
    initCaseSlider()
  })
}

export default initializeSlider
